export default __webpack_public_path__ + "static/media/instagram_post_summary_2.bd6d32e3.png";